import { render, staticRenderFns } from "./IconCaretRight.vue?vue&type=template&id=3b02e51a&scoped=true&"
import script from "./IconCaretRight.vue?vue&type=script&lang=js&"
export * from "./IconCaretRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b02e51a",
  null
  
)

export default component.exports